"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getTargetNodeName = exports.generateDDLEvent = void 0;

var generateDDLEvent = function generateDDLEvent(_ref) {
  var type = _ref.type,
      elementProp = _ref.elementProp,
      _ref$reactlytics = _ref.reactlytics,
      reactlytics = _ref$reactlytics === void 0 ? {} : _ref$reactlytics;
  var detail = reactlytics.detail,
      element = reactlytics.element;
  return {
    element: element || elementProp,
    type: reactlytics.type || type,
    detail: detail
  };
};

exports.generateDDLEvent = generateDDLEvent;

var getTargetNodeName = function getTargetNodeName() {
  var syntheticEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var event = syntheticEvent.nativeEvent || {};
  var element = event.target || {};
  return element.nodeName;
};

exports.getTargetNodeName = getTargetNodeName;
var handlerCreators = {
  onClick: function onClick(track, handler, props) {
    return function (syntheticEvent) {
      var _props$type = props.type,
          type = _props$type === void 0 ? undefined : _props$type,
          _props$reactlytics = props.reactlytics,
          reactlytics = _props$reactlytics === void 0 ? {} : _props$reactlytics;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = type || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'click'
      });
      track({
        event: event
      });
    };
  },
  onSubmit: function onSubmit(track, handler, props) {
    return function (syntheticEvent) {
      var _props$id = props.id,
          id = _props$id === void 0 ? undefined : _props$id,
          _props$reactlytics2 = props.reactlytics,
          reactlytics = _props$reactlytics2 === void 0 ? {} : _props$reactlytics2;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = id || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'submit'
      });
      track({
        event: event
      });
    };
  },
  onDismiss: function onDismiss(track, handler, props) {
    return function (syntheticEvent) {
      var _props$label = props.label,
          label = _props$label === void 0 ? undefined : _props$label,
          _props$type2 = props.type,
          type = _props$type2 === void 0 ? undefined : _props$type2,
          _props$reactlytics3 = props.reactlytics,
          reactlytics = _props$reactlytics3 === void 0 ? {} : _props$reactlytics3;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = label || type || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'dismiss'
      });
      track({
        event: event
      });
    };
  },
  onChange: function onChange(track, handler, props) {
    return function (syntheticEvent) {
      var _props$id2 = props.id,
          id = _props$id2 === void 0 ? undefined : _props$id2,
          _props$reactlytics4 = props.reactlytics,
          reactlytics = _props$reactlytics4 === void 0 ? {} : _props$reactlytics4;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = id || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'change'
      });
      track({
        event: event
      });
    };
  },
  onFocus: function onFocus(track, handler, props) {
    return function (syntheticEvent) {
      var _props$id3 = props.id,
          id = _props$id3 === void 0 ? undefined : _props$id3,
          _props$reactlytics5 = props.reactlytics,
          reactlytics = _props$reactlytics5 === void 0 ? {} : _props$reactlytics5;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = id || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'focus'
      });
      track({
        event: event
      });
    };
  },
  onBlur: function onBlur(track, handler, props) {
    return function (syntheticEvent) {
      var _props$id4 = props.id,
          id = _props$id4 === void 0 ? undefined : _props$id4,
          _props$reactlytics6 = props.reactlytics,
          reactlytics = _props$reactlytics6 === void 0 ? {} : _props$reactlytics6;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var elementProp = id || defaultElement;
      var event = generateDDLEvent({
        elementProp: elementProp,
        reactlytics: reactlytics,
        type: 'blur'
      });
      track({
        event: event
      });
    };
  },
  default: function _default(track, handler, props) {
    return function (syntheticEvent) {
      var _props$reactlytics7 = props.reactlytics,
          reactlytics = _props$reactlytics7 === void 0 ? {} : _props$reactlytics7;

      if (reactlytics.disable) {
        return;
      }

      var defaultElement = getTargetNodeName(syntheticEvent);
      var event = generateDDLEvent({
        elementProp: defaultElement,
        reactlytics: reactlytics,
        type: reactlytics.type || 'event'
      });
      track({
        event: event
      });
    };
  }
};
var _default2 = handlerCreators;
exports.default = _default2;